<section>
  <div class="form-register">
    <form [formGroup]="formServiceDetail">
      <div class="row p-1">
        <div class="col-lg-3 col-md-5 col-sm-6 col-12">
          <app-custom-input-text [value]="codeNameArticle" [disabled]="true" [labelText]="'Artículo'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
            [list]="listConceptInvoicing" [required]="true" [recovery]="true">
          </app-custom-autocomplete>
        </div>
        <div class="col-lg-3 col-md-5 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="storeId" [labelText]="'Bodega'" [list]="listStore" [required]="true"
            [recovery]="true"></app-custom-autocomplete>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-4 col-4">
          <app-custom-select formControlName="unitId" [labelText]="'Unidad'" [list]="listUnit" [required]="true"
            (onChangeSelect)="changeUnit()"></app-custom-select>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-4 col-4">
          <app-custom-input-decimal [value]="rateDiscount" [labelText]="'%Dcto'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-4 col-4">
          <app-custom-input-decimal [value]="unitValueClient" [labelText]="'Vr.Cliente'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-text formControlName="document" [labelText]="'Documento'"
            [maxLength]="9"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-datepicker formControlName="dateInitial" [labelText]="'Fecha Inicial'" [required]="true"
            (onChangeDate)="changeDates()"></app-custom-datepicker>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-datepicker formControlName="dateFinal" [labelText]="'Fecha Final'" [required]="true"
            (onChangeDate)="changeDates()"></app-custom-datepicker>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="hourMeterInitial" [labelText]="'Horóm. Ini.'"
            (onChangeNumber)="changeHourMeters()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="hourMeterFinal" [labelText]="'Horóm. Fin.'"
            (onChangeNumber)="changeHourMeters()"></app-custom-input-decimal>
        </div>
        @if (serviceModel.swOrder) {
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-decimal formControlName="quantityPending"
            [labelText]="'Pendiente'"></app-custom-input-decimal>
        </div>
        }
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="realQuantity" [labelText]="'Cant. Real'" [required]="true"
            (onChangeNumber)="validateRealQuantity($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cant. Fra.'" [required]="true"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'" [required]="true"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalValue" [labelText]="'Valor Total'"
            [required]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-2 col-6 d-flex align-items-end mb-1">
          <app-custom-checkbox formControlName="swToInvoice" [labelText]="'Se Factura'"></app-custom-checkbox>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex justify-content-start">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>